import TabsPanel from './TabsPanel';

export default TabsPanel;
